"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runIdToFrequency = void 0;
const safeMathLog = Math.log;
function runIdToFrequency(runId) {
    return 2 + ~~(safeMathLog(runId + 1) * 0.4342944819032518);
}
exports.runIdToFrequency = runIdToFrequency;
